/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LoginDto {
  /** @format email */
  email: string;
}

export interface VerifyDto {
  /** @format email */
  email: string;
  /** @pattern /^\d{6}$/ */
  code: string;
}

export interface VerifyLoginResponseDto {
  accessToken: string;
}

export interface AnalyzeBrandDto {
  /**
   * The brand website URL to analyze
   * @format uri
   * @example "https://www.nike.com"
   */
  url: string;
}

export interface BrandColorDto {
  /** @example "#FF0000" */
  hex: string;
  /** @example "Crimson Red" */
  name: string;
  /** @example "primary" */
  usage: string;
}

export interface BrandDto {
  /** @example "Nike" */
  name: string;
  colors: BrandColorDto[];
  /** @example ["Helvetica Neue","Futura"] */
  fonts: string[];
  /** @example "Bold & Athletic" */
  visualStyle: string;
  /** @example "https://example.com/logo.png" */
  logo: string | null;
  /** @example "A performance-driven brand that champions athletes worldwide." */
  summary: string;
  /** @example ["athletic","innovation","performance"] */
  keywords: string[];
  /** @example "Use bold black as the dominant background color with electric orange as the primary accent for focal elements and call-to-action details. Employ clean, angular shapes with dynamic diagonal compositions that convey motion and energy. Textures should be flat and graphic, not photorealistic. The tone should feel athletic, empowering, and forward-driven. Do not use pastels, ornate patterns, or serif-heavy typography aesthetics." */
  designDirective: string;
}

export interface WordCloudItemDto {
  /** @example "innovation" */
  word: string;
  /** @example 85 */
  weight: number;
}

export interface RegionDto {
  /** @example "United States" */
  name: string;
  /** @example 45 */
  percentage: number;
}

export interface GenderSplitDto {
  /** @example 50 */
  male: number;
  /** @example 45 */
  female: number;
  /** @example 5 */
  other: number;
}

export interface AudienceDemographicsDto {
  ageGroups: {
    range: string;
    percentage: number;
  }[];
  topRegions: RegionDto[];
  genderSplit: GenderSplitDto;
}

export interface CompetitorDto {
  /** @example "Adidas" */
  name: string;
  /** @example 72 */
  sentiment: number;
}

export interface SentimentDto {
  /** @example 78 */
  overall: number;
  /** @example 65 */
  positive: number;
  /** @example 15 */
  negative: number;
  /** @example 20 */
  neutral: number;
  /** @example ["sustainable fashion","new collection launch"] */
  trendingTopics: string[];
  wordCloud: WordCloudItemDto[];
  audienceDemographics: AudienceDemographicsDto;
  competitors: CompetitorDto[];
  /** @example ["Halloween","Back to School"] */
  suggestedRetailEvents?: string[];
}

export interface BrandAnalysisResponseDto {
  brand: BrandDto;
  sentiment: SentimentDto;
  /** @example ["style_abc","style_def"] */
  recommendedStyles: string[];
}

export interface GenerateDesignsDto {
  prompt: string;
  styleId?: string;
  /** @maxItems 3 */
  subjectImageUrls?: string[];
  trends?: string[];
  /**
   * @min 1
   * @max 12
   */
  numSamples?: number;
  brandAnalysis?: object;
  creativityLevel?: "protected" | "balanced" | "wild";
}

export interface DesignDto {
  id: string;
  userId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  imageUrl?: string;
  mockupImageUrl?: string;
  name: string;
  version: string;
  canvasStateJsonUrl?: string;
  status: "CREATED" | "REFINEMENT_REQUESTED" | "READY_FOR_REVIEW" | "APPROVED";
  productCategory: "MERCH" | "IPHONE_CASE";
  isFavorite: boolean;
  originalPrompt?: string;
  augmentedPrompt?: string;
  aspectRatio?: string;
  creativityLevel?: string;
  subjectImageUrls?: string[];
  trends?: string[];
  paletteStrategy?: string;
  paletteColors?: {
    hex: string;
    name: string;
    usage: string;
  }[];
  visualStyle?: string;
  sellingScore?: number;
  parentDesignId?: string;
}

export interface EditDesignDto {
  prompt: string;
  /** @maxItems 3 */
  subjectImageUrls?: string[];
}

export interface CreateDesignDto {
  /** @maxLength 256 */
  name: string;
}

export interface GetDesignsResponseDto {
  items: DesignDto[];
  count: number;
  favoritesCount: number;
}

export interface UpdateDesignDto {
  /**
   * @format uri
   * @maxLength 2048
   */
  canvasStateJsonUrl?: string;
}

export interface RefinementDesignDto {
  /** @maxLength 2048 */
  notes: string;
}

export interface DesignMockupDto {
  id: string;
  designId: string;
  status: "PENDING" | "COMPLETED" | "FAILED";
  mockupImageUrl?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PostMultipleSubjectsBody {
  /**
   * The prompt for generating images
   * @example "A futuristic cityscape with flying cars"
   */
  prompt: string;
  /**
   * An array of URLs of subject images to condition the generation on
   * @example ["https://example.com/subject1.jpg","https://example.com/subject2.jpg"]
   */
  subjectImageUrls?: string[];
  /**
   * An array of trends to apply to the generated images
   * @example ["vaporwave","synthwave"]
   */
  trends?: string[];
  /**
   * The number of images to generate
   * @example 4
   */
  numSamples?: number;
}

export interface PostMultipleSubjectsResponse {
  /**
   * The unique identifier of the generated image
   * @example "image-12345"
   */
  id: string;
  /**
   * The URL where the generated image can be accessed
   * @example "https://example.com/generated-image.jpg"
   */
  url: string;
}

export interface UploadDto {
  /**
   * MIME type of the file to upload
   * @example "image/png"
   */
  contentType:
    | "application/json"
    | "image/jpeg"
    | "image/png"
    | "image/jpg"
    | "image/gif"
    | "image/webp"
    | "image/svg"
    | "image/tiff"
    | "image/heic"
    | "image/heif"
    | "image/bmp"
    | "text/plain";
}

export interface UploadResponseDto {
  /**
   * Signed URL for uploading the file
   * @example "https://storage.googleapis.com/bucket/..."
   */
  url: string;
  /**
   * Expiration date of the signed URL
   * @example "2026-02-07T00:00:00.000Z"
   */
  expiresAt: string;
}

export interface SmartObjectDto {
  /**
   * UUID of the smart object on the mockup template
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  uuid: string;
  /**
   * URL of the design image to place on the smart object
   * @example "https://example.com/design.png"
   */
  imageUrl: string;
  /**
   * Optional background color for the smart object
   * @example "#FF5733"
   */
  color?: string;
}

export interface MockupRenderItemDto {
  /**
   * UUID of the mockup template to render
   * @example "b2c3d4e5-f6a7-8901-bcde-f12345678901"
   */
  mockupUuid: string;
  /** Smart objects to place on the mockup */
  smartObjects: SmartObjectDto[];
}

export interface RenderMockupsBody {
  /** Array of mockup render requests */
  renders: MockupRenderItemDto[];
}

export interface MockupRenderResultDto {
  /**
   * Status of the render
   * @example "completed"
   */
  status: string;
  /**
   * URL of the rendered mockup image
   * @example "https://exports.dynamicmockups.com/renders/abc123.png"
   */
  exportPath: string;
  /**
   * UUID of the mockup template that was rendered
   * @example "b2c3d4e5-f6a7-8901-bcde-f12345678901"
   */
  mockupUuid: string;
}

export interface RenderMockupsResponse {
  /**
   * Total number of renders requested
   * @example 3
   */
  totalRenders: number;
  /**
   * Number of renders that succeeded
   * @example 3
   */
  successfulRenders: number;
  /**
   * Number of renders that failed
   * @example 0
   */
  failedRenders: number;
  /** Array of render results */
  renders: MockupRenderResultDto[];
}

export interface TriggerReviewDto {
  brandAnalysis?: object;
}

export interface ReviewDimensionDto {
  name: string;
  label: string;
  status: "PASS" | "WARNING" | "FAIL" | "SKIPPED";
  rationale: string;
}

export interface DesignReviewDto {
  id: string;
  designId: string;
  status: "PENDING" | "COMPLETED" | "FAILED";
  dimensions?: ReviewDimensionDto[];
  issueCount?: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type CreateImageFavoriteBody = object;

export interface User {
  id: string;
  email: string;
  /** @format date-time */
  createdAt: string;
}

export interface CreateImageFavoriteResponse {
  /** @format uuid */
  id: string;
  /** @format uuid */
  imageId: string;
  /** @format uuid */
  userId: string;
  user: User;
  /** @format date-time */
  createdAt: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Ablo Studio API
 * @version 1.0.0
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogin
     * @request POST:/auth/login
     * @secure
     */
    authControllerLogin: (data: LoginDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerVerify
     * @request POST:/auth/verify
     * @secure
     */
    authControllerVerify: (data: VerifyDto, params: RequestParams = {}) =>
      this.request<VerifyLoginResponseDto, any>({
        path: `/auth/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brandAnalysis = {
    /**
     * @description Analyze a brand website and return brand insights, sentiment, and style recommendations
     *
     * @tags Brand Analysis
     * @name BrandAnalysisControllerAnalyzeBrand
     * @request POST:/brand-analysis/analyze
     * @secure
     */
    brandAnalysisControllerAnalyzeBrand: (
      data: AnalyzeBrandDto,
      params: RequestParams = {},
    ) =>
      this.request<BrandAnalysisResponseDto, any>({
        path: `/brand-analysis/analyze`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  designs = {
    /**
     * No description
     *
     * @tags Design
     * @name DesignControllerGenerateDesigns
     * @request POST:/designs/generate
     * @secure
     */
    designControllerGenerateDesigns: (
      data: GenerateDesignsDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignDto[], any>({
        path: `/designs/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Edit an existing design to generate new variations
     *
     * @tags Design
     * @name DesignControllerEditDesign
     * @request POST:/designs/{id}/edit
     * @secure
     */
    designControllerEditDesign: (
      id: string,
      data: EditDesignDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignDto[], any>({
        path: `/designs/${id}/edit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Design
     * @name DesignControllerCreateDesign
     * @request POST:/designs
     * @secure
     */
    designControllerCreateDesign: (
      data: CreateDesignDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignDto, any>({
        path: `/designs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get designs by user
     *
     * @tags Design
     * @name DesignControllerGetDesigns
     * @request GET:/designs
     * @secure
     */
    designControllerGetDesigns: (
      query: {
        /**
         * @min 0
         * @default 0
         */
        skip: number;
        /**
         * @min 1
         * @default 10
         */
        take: number;
        isFavorite?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDesignsResponseDto, any>({
        path: `/designs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a design by ID
     *
     * @tags Design
     * @name DesignControllerDeleteDesign
     * @request DELETE:/designs/{id}
     * @secure
     */
    designControllerDeleteDesign: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/designs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Update a design by ID
     *
     * @tags Design
     * @name DesignControllerUpdateDesign
     * @request PATCH:/designs/{id}
     * @secure
     */
    designControllerUpdateDesign: (
      id: string,
      data: UpdateDesignDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignDto, any>({
        path: `/designs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Request refinement for a design by ID
     *
     * @tags Design
     * @name DesignControllerRequestRefinement
     * @request POST:/designs/{id}/refinement
     * @secure
     */
    designControllerRequestRefinement: (
      id: string,
      data: RefinementDesignDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignDto, any>({
        path: `/designs/${id}/refinement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get mockups for a design
     *
     * @tags Design
     * @name DesignControllerGetDesignMockups
     * @request GET:/designs/{id}/mockups
     * @secure
     */
    designControllerGetDesignMockups: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DesignMockupDto[], any>({
        path: `/designs/${id}/mockups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Favorite Designs
     * @name FavoriteDesignControllerFavoriteDesign
     * @request POST:/designs/{designId}/favorite
     * @secure
     */
    favoriteDesignControllerFavoriteDesign: (
      designId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/designs/${designId}/favorite`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Favorite Designs
     * @name FavoriteDesignControllerUnfavoriteDesign
     * @request DELETE:/designs/{designId}/favorite
     * @secure
     */
    favoriteDesignControllerUnfavoriteDesign: (
      designId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/designs/${designId}/favorite`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Trigger AI review for a design
     *
     * @tags Design Review
     * @name DesignReviewControllerTriggerReview
     * @request POST:/designs/{id}/review
     * @secure
     */
    designReviewControllerTriggerReview: (
      id: string,
      data: TriggerReviewDto,
      params: RequestParams = {},
    ) =>
      this.request<DesignReviewDto, any>({
        path: `/designs/${id}/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get AI review results for a design
     *
     * @tags Design Review
     * @name DesignReviewControllerGetReview
     * @request GET:/designs/{id}/review
     * @secure
     */
    designReviewControllerGetReview: (id: string, params: RequestParams = {}) =>
      this.request<DesignReviewDto, any>({
        path: `/designs/${id}/review`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  imageMaker = {
    /**
     * @description Post Multiple Subjects
     *
     * @tags Image Maker
     * @name ImageMakerControllerPostMultipleSubjects
     * @request POST:/image-maker/multiple-subjects
     * @secure
     */
    imageMakerControllerPostMultipleSubjects: (
      data: PostMultipleSubjectsBody,
      params: RequestParams = {},
    ) =>
      this.request<PostMultipleSubjectsResponse[], any>({
        path: `/image-maker/multiple-subjects`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  storage = {
    /**
     * @description Upload a file to the storage
     *
     * @tags Storage
     * @name StorageControllerUpload
     * @request POST:/storage/upload
     * @secure
     */
    storageControllerUpload: (data: UploadDto, params: RequestParams = {}) =>
      this.request<UploadResponseDto, any>({
        path: `/storage/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  dynamicMockups = {
    /**
     * @description Render design images onto mockup templates
     *
     * @tags Dynamic Mockups
     * @name DynamicMockupsControllerRenderMockups
     * @request POST:/dynamic-mockups/render
     * @secure
     */
    dynamicMockupsControllerRenderMockups: (
      data: RenderMockupsBody,
      params: RequestParams = {},
    ) =>
      this.request<RenderMockupsResponse, any>({
        path: `/dynamic-mockups/render`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  imageFavorites = {
    /**
     * @description Create a new image favorite
     *
     * @tags ImageFavorites
     * @name ImageFavoriteControllerFavoriteImage
     * @request POST:/image-favorites
     * @secure
     */
    imageFavoriteControllerFavoriteImage: (
      data: CreateImageFavoriteBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateImageFavoriteResponse, any>({
        path: `/image-favorites`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an image favorite
     *
     * @tags ImageFavorites
     * @name ImageFavoriteControllerUnfavoriteImage
     * @request DELETE:/image-favorites/{id}
     * @secure
     */
    imageFavoriteControllerUnfavoriteImage: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/image-favorites/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
